import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import PendingAgendaDataTable from "../DataTable/agenda/PendingAgendaDataTable";


function AddPendingAgendaDialog({ onClose, open, handleAddPendingAgenda }) {

    return (
        <Dialog onClose={onClose} open={open} fullWidth maxWidth="lg">
            <DialogTitle>Gündem Ekle</DialogTitle>
            <DialogContent dividers>
                <PendingAgendaDataTable handleAddPendingAgenda={handleAddPendingAgenda} onClose={onClose} />
            </DialogContent>
            <DialogActions>
            </DialogActions>
        </Dialog>
    );
}

export default AddPendingAgendaDialog